/* eslint-disable max-len */
import { passportFetch } from '~/services/fetch-passport'

// Update if Agree receive Newsletter
export function updateReceiveNewsletter(marketing_consent: boolean, userName: string) {
  return passportFetch.post('/api/authenticated/user/fields?xrequestedwith=xmlhttprequest', { json: { fields: { marketing_consent, userName } } })
    .json()
}

// Update if Agree Privacy Policy
export function updatePrivacyPolicy(dpp_consent: boolean) {
  return passportFetch.post('/api/authenticated/user/fields?xrequestedwith=xmlhttprequest', { json: { fields: { dpp_consent } } })
    .json()
}
